<template>
  <div>
    <v-main>
      <div
        style="padding: 28px;padding-top: 28px;min-height: 120%;height: auto;"
        v-if="data === true"
      >
        <v-row style=" height: 20px;">
          <v-col xs="10" sm="10" md="10" lg="10" style="padding-bottom:0">
            <h2>ตั้งค่าหน้าสมัครสมาชิก</h2>
          </v-col>
        </v-row>
        <br />
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-divider style="padding-top:0;margin-top: 1rem;margin-bottom: 1rem;"></v-divider>
              <div style="border: solid #cbcbcb;padding: 20px;border-radius: 20px;">
                <h3 style="font-weight: bold;;">ข้อมูลที่ต้องการ</h3>
                <br />
                <h3>ชื่อ-สกุล</h3>
                <v-divider style="padding-top:0;margin-top: 1rem;margin-bottom: 1rem;"></v-divider>
                <h3>เบอร์โทรศัพท์</h3>
                <v-divider style="padding-top:0;margin-top: 1rem;margin-bottom: 1rem;"></v-divider>
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <h3>วันเกิด</h3>
                  <v-switch
                    class="mt-0 pt-0"
                    hide-details
                    inset
                    label="แสดง"
                    :input-value="!isSystemFieldHidden('birthDay')"
                    @change="toggleSystemField('birthDay', $event)"
                  ></v-switch>
                </div>
                <v-divider style="padding-top:0;margin-top: 1rem;margin-bottom: 1rem;"></v-divider>
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <h3>เพศ</h3>
                  <v-switch
                    class="mt-0 pt-0"
                    hide-details
                    inset
                    label="แสดง"
                    :input-value="!isSystemFieldHidden('gender')"
                    @change="toggleSystemField('gender', $event)"
                  ></v-switch>
                </div>
                <v-divider style="padding-top:0;margin-top: 1rem;margin-bottom: 1rem;"></v-divider>
                <div v-for="item in visibleCustomFields" :key="item.fieldId">
                  <div style="display: flex;justify-content: space-between;">
                    <h3>{{ item.fieldName }}</h3>
                    <div>
                      <!-- <v-btn
                        class="btnEdit"
                        dark
                        small
                        @click="dataget(item)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn> -->
                      <v-btn color="#d36666" small dark @click="deletesdata(item)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <v-divider style="padding-top:0;margin-top: 1rem;margin-bottom: 1rem;"></v-divider>
                </div>

                <v-btn color="accent" @click="(data = false), (add = true)"
                  >เพิ่ม</v-btn
                >
              </div>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" class="pt-0">
            <!-- <h3 style="font-weight: bold;;">แสดงตัวอย่าง</h3> -->
            <br/>
            <v-row style="justify-content: center; ;">
              <div style="justify-content:center ;">
                <v-card
                  style="width:450px;min-height:690px;border: 1px solid black"
                >
                  <div style="overflow-y: auto;height:auto">
                    <div
                      class="pa-4 div1"
                      style=" border-top-left-radius: 11px;border-top-right-radius: 11px;"
                      :style="
                        'z-index: 0;position: relative;min-height:180px;background-image: linear-gradient(0deg,' +
                          hexToRgbA(them.slice(0, -2)) +
                          '  0%,' +
                          bgColor2(hexToRgbA(them.slice(0, -2))) +
                          ' 100%);'
                      "
                    >
                      <div
                        :style="
                          'height: 143px;background-color:' +
                            bgColor2(hexToRgbA(them.slice(0, -2))) +
                            ';width: 143px;border-radius: 100px;position: absolute;z-index: -1;right: 14px;top: -52px;'
                        "
                      ></div>
                      <div
                        :style="
                          'height: 90px;background-color:' +
                            bgColor2(hexToRgbA(them.slice(0, -2))) +
                            ';width: 45px;border-top-left-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 1px;top: 29px;'
                        "
                      ></div>
                      <div
                        :style="
                          'height: 89px;background-color:' +
                            bgColor3(bgColor2(hexToRgbA(them.slice(0, -2)))) +
                            ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 17px;top: 58px;'
                        "
                      ></div>
                      <div
                        :style="
                          'height: 89px;background-color:' +
                            bgColor3(bgColor2(hexToRgbA(them.slice(0, -2)))) +
                            ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 73px;top: 70px;'
                        "
                      ></div>
                      <div
                        style="display: flex;
    align-items: center;
    justify-content: center;padding-top: 20px;"
                      >
                        <v-avatar color="primary" size="84">
                          <v-img :src="session.data.logo"></v-img>
                        </v-avatar>
                      </div>
                      <div
                        style="display: flex;
    align-items: center;
    justify-content: center;padding-top: 20px;padding-bottom: 20px;"
                      >
                        <h3 :style="'color:' + HEXToVBColor(them)">
                          {{ this.$session.getAll().data.name }}
                        </h3>
                      </div>
                    </div>
                    <v-container>
                      <p style="margin: 0">ชื่อ-นามสกุล</p>
                      <v-text-field solo-inverted dense disabled></v-text-field>
                      <p style="margin: 0">เบอร์โทรศัพท์</p>
                      <v-text-field solo-inverted dense disabled></v-text-field>
                      <p v-if="!isSystemFieldHidden('birthDay')" style="margin: 0">วันเกิด</p>
                      <v-text-field
                        v-if="!isSystemFieldHidden('birthDay')"
                        solo-inverted
                        dense
                        append-icon="mdi-calendar"
                        disabled
                      ></v-text-field>
                      <p v-if="!isSystemFieldHidden('gender')" style="margin: 0">เพศ</p>
                      <v-select v-if="!isSystemFieldHidden('gender')" solo-inverted dense disabled></v-select>
                      <div v-for="item in visibleCustomFields" :key="item.fieldId">
                        <p style="margin: 0">{{ item.fieldName }}</p>
                        <div v-if="item.fieldType === 'text'">
                          <v-text-field
                            solo-inverted
                            dense
                            disabled
                          ></v-text-field>
                        </div>
                        <div v-if="item.fieldType === 'email'">
                          <v-text-field
                            solo-inverted
                            dense
                            disabled
                          ></v-text-field>
                        </div>

                        <div v-if="item.fieldType === 'checkbox'">
                          <v-checkbox
                            v-for="items in JSON.parse(item.answer)"
                            :key="items"
                            :value="items"
                            :label="items"
                          ></v-checkbox>
                        </div>

                        <div v-if="item.fieldType === 'radio'" >
                          <v-select
                            outlined
                            dense
                            style="background-color: #efefef;"
                            hide-details
                            :items="JSON.parse(item.answer)"
                          ></v-select>
                        </div>
                      </div>
                      <br />
                      <v-btn block color="#1b437c" dark
                        >ยืนยันสมัครสมาชิก</v-btn
                      >
                    </v-container>
                  </div>
                </v-card>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div v-if="add === true">
        <v-row style="padding:20px 5px 0 0;" class="text-end">
          <v-col>
            <v-btn outlined @click="(add = false), (data = true), clear()">
              กลับ
            </v-btn>
          </v-col>
        </v-row>
        <v-row style="justify-content: center; ;">
          <v-container style=" width: 600px">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <h2 class="text-center">เลือกรูปแบบคำตอบ</h2>
              </v-col>
            </v-row>
            <v-row justify-content-center style="padding-bottom: 70px;">
              <v-col cols="6" xs="6" sm="6" md="6" lg="6">
                <v-card class="card-select" @click="formAdd.fieldType = 'text'">
                  <div class="text-center pt-5">
                    <v-avatar tile>
                      <!-- <v-img :src="require('@/assets/icon4-02.svg')"></v-img> -->
                    </v-avatar>
                  </div>

                  <p class="text-center ">ข้อความ</p>
                </v-card>
              </v-col>
              <!-- <v-col cols="4" xs="4" sm="4" md="4" lg="4">
                <v-card
                  class="card-select"
                  @click="formAdd.fieldType = 'checkbox'"
                >
                  <div class="text-center pt-5">
                    <v-avatar tile>
                    </v-avatar>
                  </div>
                  <p class="text-center ">มากกว่า 1 ตัวเลือก</p>
                </v-card>
              </v-col> -->
              <v-col cols="6" xs="6" sm="6" md="6" lg="6">
                <v-card
                  class="card-select"
                  @click="formAdd.fieldType = 'radio'"
                >
                  <div class="text-center pt-5">
                    <v-avatar tile>
                      <!-- <v-img :src="require('@/assets/icon2-01.svg')"></v-img> -->
                    </v-avatar>
                  </div>
                  <p class="text-center ">ตัวเลือก</p>
                </v-card>
              </v-col>
              <v-col cols="12" md="12" lg="12" style="padding: 16px 16px 0">
                <v-row>
                  <v-col>
                    <h2>หัวข้อคำถาม</h2>
                    <v-text-field
                      v-model="formAdd.fieldName"
                      label="หัวข้อคำถาม"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="formAdd.fieldType !== 'text' && formAdd.fieldType !== 'email'">
                  <v-col
                    v-for="(item, i) in formAdd.answer"
                    :key="i"
                    class="mt pa-4"
                    cols="12"
                  >
                    <h2>คำตอบ</h2>
                    <div v-for="(item2, index) in item" :key="index">
                      <v-text-field
                        v-model="item[index]"
                        append-icon="mdi-close-circle"
                        class="pa-0 mb-2"
                        background-color="#f2f4f9"
                        :rules="[rules.required]"
                        :label="'คำตอบ ' + (index + 1)"
                        @click:append="toggleMarker(item2, item)"
                        outlined
                        hide-details
                        dense
                      >
                        <template> </template>
                      </v-text-field>
                    </div>
                    <v-btn color="#424242" dark block @click="addChoice(item)"
                      >เพิ่มคำตอบ
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- <v-row v-if="formAdd.fieldType !== 'checkbok'"></v-row> -->
                <v-row v-if="formAdd.fieldType !== 'text' && formAdd.fieldType !== 'email'">
                  <v-col>
                    <h4>สามารถกรอกคำตอบอื่นได้</h4>
                  </v-col>
                  <v-col style="padding: 0;">
                    <v-switch
                      v-model="formAdd.anotherAnswer"
                      inset
                      style="padding: 0;"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h4>แสดง</h4>
                  </v-col>
                  <v-col style="padding: 0;">
                    <v-switch
                      v-model="formAdd.showCard"
                      inset
                      style="padding: 0;"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h4>บังคับให้ใส่</h4>
                  </v-col>
                  <v-col style="padding: 0;align-items: end;">
                    <v-switch
                      v-model="formAdd.requiredField"
                      inset
                      style="padding: 0;"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-btn @click="submit()" dark color="primary" block
                  >บันทึก</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </div>
      <div v-if="aa === true">
        <v-row style="padding:20px 5px 0 0;" class="text-end">
          <v-col>
            <v-btn outlined @click="(edit = false), (data = true), clear()"
              >ยกเลิก
            </v-btn>
          </v-col>
        </v-row>
        <v-row style="justify-content: center; ;">
          <v-container style=" width: 600px">
            <v-row>
              <v-col cols="12" md="12" lg="12" style="padding: 16px 16px 0">
                <v-row>
                  <v-col>
                    <h2>หัวข้อคำถาม</h2>
                    <v-text-field
                      v-model="formUpdate.fieldname"
                      label="หัวข้อคำถาม"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.fieldType !== 'text'">
                  <v-col class="mt pa-4" cols="12">
                    <h2>คำตอบ</h2>
                    <div
                      v-for="(item2, index) in formUpdate.answer"
                      :key="index"
                    >
                      <div v-for="i in JSON.parse(item2)" :key="i">
                        <!-- <h1>{{ index }}</h1> -->
                        <v-text-field
                          v-model="dataedit[index]"
                          append-icon="mdi-close-circle"
                          class="pa-0 mb-2"
                          background-color="#f2f4f9"
                          :rules="required"
                          :label="'คำตอบ ' + (index + 1)"
                          @click:append="toggleMarker(item2, item)"
                          outlined
                          hide-details
                          dense
                        >
                        </v-text-field>
                      </div>
                    </div>
                    <v-btn color="#424242" dark block @click="addChoice2(item2)"
                      >เพิ่มคำตอบ
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h4>แสดง</h4>
                  </v-col>
                  <v-col style="padding: 0;">
                    <v-switch
                      v-model="formUpdate.showCard"
                      inset
                      style="padding: 0;"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h4>บังคับให้ใส่</h4>
                  </v-col>
                  <v-col style="padding: 0;align-items: end;">
                    <v-switch
                      v-model="formUpdate.requiredField"
                      inset
                      style="padding: 0;"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-btn @click="update()" dark color="primary" block
                  >บันทึก</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
export default {
  data () {
    return {
      session: this.$session.getAll(),
      btnStatusWel: '',
      label: ['ชื่อ-สกุล', 'เบอร์โทรศัพท์', 'วันเกิด', 'เพศ'],
      dataCustomFeild: [],
      dataCustomFeildAdd: [],
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      formAdd: {
        fieldName: '',
        fieldType: 'text',
        showCard: false,
        requiredField: false,
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: '',
        answer: [['', '', '']]
      },
      formUpdate: {
        fieldId: '',
        fieldName: '',
        fieldType: '',
        showCard: false,
        requiredField: false,
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: '',
        answer: ['', '', '']
      },
      data: true,
      add: false,
      aa: false,
      radioGroup: 1,
      dataType: [
        {
          text: 'ข้อความ',
          value: 'text',
          src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg'
        },
        {
          text: 'มากกว่า 1 ตัวเลือก',
          value: 'checkbox',
          src: 'https://cdn.vuetifyjs.com/images/cards/halcyon.png'
        },
        {
          text: '1 ตัวเลือก',
          value: 'radio',
          src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg'
        }
      ],
      them: [],
      dataanswer: [],
      dataedit: [],
      status: ''
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.getThem()
    this.getDataCustomFeildFix()
    this.hexToRgbA(this.them.slice(0, -2))
  },
  computed: {
    visibleCustomFields () {
      return (Array.isArray(this.dataCustomFeild) ? this.dataCustomFeild : [])
        .filter(i => i.fieldType !== 'hideSystemField')
    }
  },
  methods: {
    deletesdata (item) {
      this.formUpdate.LAST_USER = this.session.data.userName
      this.$swal({
        title: 'กรุณายืนยัน',
        type: 'question',
        text:
          'การลบคำถามนี้จะทำให้ข้อมูลเดิมของลูกค้าบางส่วนหายไป คุณแน่ใจที่จะลบคำถามนี้ใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          await axios
            .post(
              this.DNS_IP + '/CustomField/delete/' + item.fieldId,
              this.formUpdate
            )
            .then(async response => {
              // console.log('DNS_IP + PATH + "delete/"', response)
              // console.log('status', status)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              this.dialogDelete = false

              this.getThem()
              this.getDataCustomFeildFix()
              this.hexToRgbA(this.them.slice(0, -2))
            })
        })
        .catch(error => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    dataget (item) {
      try {
        this.dataedit = []
        var a = JSON.parse(item.answer)
        // console.log('item', typeof a)
        // console.log('item', item.fieldType)
        for (var k in a) {
          this.dataedit.push(a[k])
        }
        // console.log('k', a[k])
        // console.log('k', this.dataedit)
        this.formUpdate.fieldname = item.fieldName
        this.formUpdate.fieldId = item.fieldId
        // console.log('this.formUpdate.fieldname', this.formUpdate.fieldname)
        this.formUpdate.fieldType = item.fieldType
        this.formUpdate.answer = item.answer
        if (item.showCard.toLowerCase() === 'true') {
          this.formUpdate.showCard = true
        } else {
          this.formUpdate.showCard = false
        }
        if (item.requiredField.toLowerCase() === 'true') {
          this.formUpdate.requiredField = true
        } else {
          this.formUpdate.requiredField = false
        }
        this.aa = true
        this.data = false
      } catch (error) {
        console.log('error', error)
      }
    },
    getThem () {
      axios
        .get(this.DNS_IP + '/color/get?shopId=' + this.session.data.shopId)
        .then(res => {
          this.them = res.data[0].color1
          // console.log('this.them', this.them)
        })
    },
    hexToRgbA (hex) {
      var c
      c = hex.substring(1).split('')
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = '0x' + c.join('')
      return (
        'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ')'
      )
    },
    bgColor2 (rgb) {
      // console.log('rgb', rgb)
      var c = rgb
        .slice(3)
        .slice(1, -1)
        .split(',')
      // console.log('ddddds', c)
      // console.log(
      //   'rgb(' +
      //     (parseInt(c[0]) + 50) +
      //     ',' +
      //     (parseInt(c[1]) + 50) +
      //     ',' +
      //     (parseInt(c[2]) + 50) +
      //     ')'
      // )
      return (
        'rgb(' +
        (parseInt(c[0]) + 50) +
        ',' +
        (parseInt(c[1]) + 50) +
        ',' +
        (parseInt(c[2]) + 50) +
        ')'
      )
    },
    bgColor3 (rgb) {
      // console.log('rgb', rgb)
      var c = rgb
        .slice(3)
        .slice(1, -1)
        .split(',')
      // console.log('ddddds', c)
      return (
        'rgb(' +
        (parseInt(c[0]) + 50) +
        ',' +
        (parseInt(c[1]) + 50) +
        ',' +
        (parseInt(c[2]) + 50) +
        ', 0.3)'
      )
    },
    HEXToVBColor (a) {
      let rr = parseInt(a.substr(1, 2), 16)
      let gg = parseInt(a.substr(3, 2), 16)
      let bb = parseInt(a.substr(5, 2), 16)

      // console.log('rrrr', rr * 0.299 + gg * 0.587 + bb * 0.114)
      if (rr * 0.299 + gg * 0.587 + bb * 0.114 > 186) {
        let black = '#000000'
        return black
      } else {
        let white = '#ffffff'
        return white
      }
    },
    // ช่องเดิมของหน้าสมัคร (วันเกิด/เพศ) ซ่อนได้รายร้าน: เก็บเป็นแถว CustomField ชนิด hideSystemField
    // ร้านที่ไม่เคยกดสวิตช์จะไม่มีแถวนี้ หน้าสมัครจึงเหมือนเดิม
    systemHideRow (name) {
      return (Array.isArray(this.dataCustomFeild) ? this.dataCustomFeild : [])
        .find(i => i.fieldType === 'hideSystemField' && i.fieldName === name)
    },
    isSystemFieldHidden (name) {
      return !!this.systemHideRow(name)
    },
    async toggleSystemField (name, show) {
      const row = this.systemHideRow(name)
      const user = this.session.data.userName
      if (!show && !row) {
        await axios.post(this.DNS_IP + '/CustomField/add', {
          fieldName: name,
          fieldType: 'hideSystemField',
          showCard: true,
          requiredField: false,
          shopId: this.session.data.shopId,
          CREATE_USER: user,
          LAST_USER: user
        })
      } else if (show && row) {
        await axios.post(this.DNS_IP + '/CustomField/delete/' + row.fieldId, { LAST_USER: user })
      }
      await this.getDataCustomFeildFix()
    },
    async getDataCustomFeildFix () {
      this.dataCustomFeild = []
      await axios
        .get(
          this.DNS_IP + '/CustomField/get?shopId=' + this.session.data.shopId
        )
        .then(res => {
          this.dataCustomFeild = res.data
          if (res.data.status === false) {
            this.dataCustomFeild = []
          } else {
            this.dataCustomFeild = res.data
          }
          // console.log('res', this.dataCustomFeild)
        })
    },
    async submit () {
      this.formAdd.CREATE_USER = this.session.data.userName
      this.formAdd.LAST_USER = this.session.data.userName
      if (
        this.formAdd.fieldType === 'checkbox' ||
        this.formAdd.fieldType === 'radio'
      ) {
        this.formAdd.answer = JSON.stringify(this.formAdd.answer.flat())
          .trim()
          .replace(/(\r\n|\n|\r)/gm, '')
          .replace(/'/g, "\\'")
          .replace(/%/g, '%%')
        // console.log('stringify2', this.formAdd.answer)
      } else {
        this.formAdd.answer = null
      }
      console.log('this.formAdd', this.formAdd)
      this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success').then(
        async res => {
          await axios
            .post(this.DNS_IP + '/CustomField/add', this.formAdd)
            .then(async response => {
              // console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              this.getDataCustomFeildFix()
            })
        }
      )

      this.add = false
      this.data = true
    },
    async update () {
      this.formUpdate.CREATE_USER = this.session.data.userName
      this.formUpdate.LAST_USER = this.session.data.userName
      if (
        this.formUpdate.fieldType === 'checkbox' ||
        this.formUpdate.fieldType === 'radio'
      ) {
        this.formAdd.answer = JSON.stringify(this.formUpdate.answer)
          .trim()
          .replace(/(\r\n|\n|\r)/gm, '')
          .replace(/'/g, "\\'")
          .replace(/%/g, '%%')
        // console.log('stringify2', this.formAdd.answer)
      } else {
        this.formUpdate.answer = null
      }
      console.log('this.formAdd', this.formUpdate)
      // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success').then(
      //   async res => {
      //     await axios
      //       .post(this.DNS_IP + '/CustomField/edit/', this.formAdd)
      //       .then(async response => {
      //         // console.log('addDataGlobal DNS_IP + PATH + "add"', response)
      //         this.getDataCustomFeildFix()
      //       })
      //   }
      // )

      // this.add = false
      // this.data = true
    },
    addChoice (item) {
      item.push('')
      // console.log(item)
    },
    addChoice2 (item2) {
      item2.push('')
      // console.log(item2)
    },
    toggleMarker (item2, item) {
      console.log('sd', item2)
      // console.log('sd2', item)
      this.formAdd.answer.map(a => {
        if (a === item) {
          a.splice(item2, 0)
        }
      })
    },
    clear () {
      this.formAdd.fieldName = ''
      this.formAdd.fieldType = 'text'
      this.formAdd.showCard = false
      this.formAdd.requiredField = false
      this.formAdd.answer = [['', '', '']]
    }
  }
}
</script>
<style scoped>
div .div1 {
  width: 100%;
  height: 180px;
  /* display: flex;
    align-items: center;
    justify-content: center; */
}
.btnEdit {
  background-color: #5c99db !important;
}
.card-select {
  min-width: 110px;
  max-width: 170px;
  min-height: 120px;
  /* margin: 0px 5px;
  padding: 0px 5px; */
  /* padding: 0px 12px; */
}
</style>



// WEBPACK FOOTER //
// src/components/System/customField.vue